import { proxy } from 'web-worker-proxy';
import sign from './auth/sign';
import Deferred from './auth/Deferred';

const apiUrl = import.meta.env.VITE_API_URL;
const secret = '8d8PzTFCFq5oq5AVpMEIoxgB0qqkqH2';
const graphqlURL = apiUrl + '/graphql';
const refreshTokenURL = `${apiUrl}/refresh_token`;
const logoutURL = `${apiUrl}/logout`;

type SecretCache = {
  ready: Deferred<any>,
  uniqueId: string | null;
  authToken: string | null;
};

const ready = new Deferred();
const cache: SecretCache = {
  ready,
  uniqueId: null,
  authToken: null,
};

proxy({
  fetch: async (options: any) => {
    await cache.ready;
    const token = cache?.authToken;
    const uniqueId = cache?.uniqueId;
    const bearer = sign({ type: 'auth', app: 'webapp', uniqueId, token }, secret);
    return fetch(graphqlURL, {
      credentials: 'include',
      ...options,
      headers: {
        ...options?.headers,
        authorization: bearer ? `Bearer ${bearer}` : "",
      },
    }).then(async res => ({
      body: await res.text(),
      status: res.status,
      statusText: res.statusText,
    }));
  },

  setup: async (uniqueId: string, referralToken?: string) => {
    try {
      const data = await fetch(`${refreshTokenURL}${referralToken ? '?referralToken=' + referralToken : ''}`, { credentials: "include" }).then(res => res.json());
      cache.authToken = data?.authToken;
      cache.uniqueId = uniqueId;
      cache.ready.resolve();
      return Boolean(cache.authToken);
    } catch (err) {
      return false;
    }
  },

  setAuthToken: async (authToken: string) => {
    cache.authToken = authToken;
  },

  logout: async () => {
    await fetch(logoutURL, { credentials: "include" });
    cache.authToken = null;
  },
});
